import { update } from 'state/util';
import { STATUS } from 'state/requestStatus/reducer';

/**
 *  data: null||{
 *    username: ...
 *    ... user properties ...
 *  },
 *  message: null||"update status"
 */

const initialState = {
  data: null,
  message: null,
};

// user reducer, for registering, logging in, etc
export const userReducer = (state, action) => {
  if (state === undefined)
    return initialState;

  switch(action.type) {
    case "LOGOUT_REQUESTED":
      return initialState;

    // set the user from the login saga action response
    // LOGIN_SUCCESSFUL action payload is:
    // { auth: ..., user: { data: {userdata}, message: ... } }
    case "LOGIN_SUCCESSFUL":
      return update(state, {
        data: action.payload.user.data,
      });

    case "LOGIN_FAILED":
      return initialState;

    case "GET_USER_SUCCESSFUL":
      return update(state, {
        data: action.payload.data,
      });

    case "UPDATE_USER_SUCCESSFUL":
      return update(state, {
        data: action.payload.data,
        message: "User saved!",
        status: STATUS.COMPLETE,
      });

    case "GET_USER_PENDING":
    case "UPDATE_USER_PENDING":
      return update(state, {
        message: 'Updating user...',
        status: STATUS.PENDING,
      });

    case "GET_USER_FAILED":
    case "UPDATE_USER_FAILED":
      return update(state, {
        message: action.payload.message,
        status: STATUS.FAILED,
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/user/reducer.js